/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  bus
} from '../../main';
import {
  mapGetters,
  mapState
} from 'vuex';
import axios from 'axios';
import root from '../../_helpers/roots';
export default {
  name: 'note-create',
  components: {},
  props: ['courseId'],
  data() {
    return {
      name: '',
      description: '',
      submitted: false,
      uploadingLoader: false,
    }
  },
  computed: {
  },
  mounted() {
    console.log(this.$route.params.id, "Test")
  },
  methods: {
    validateFileBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.uploadingLoader = true
          let formData = new FormData();
          formData.append('course', this.courseId);
          formData.append('name', this.name);
          formData.append('description', this.description);
          $('.courseloader').show(); 
          this.$store.dispatch('createdUserNotes', formData).then(response => {
            if (response.status === 201) {
              this.name = '';
              this.description = '';
              toast.success(response.data.msg);
              this.$validator.reset();
              $('.courseloader').hide();
              bus.$emit('HideAddNewNotePopup', {
                status: false,
                reload: true
              })
            }
          }).catch(err => {
            console.error(err);
            $('.courseloader').hide();
            this.popupCloseFun()
          })
          return
        }
      });
    },
    popupCloseFun() {
      bus.$emit('HideAddNewNotePopup', {
        status: false,
        reload: false
      })
    },
    resetFileBefore() {
      this.$validator.reset();
    }
  }
}